export default ({ response }) => response;
